import gql from 'graphql-tag'

export const companyLogo = gql`
  query CompanyLogo($accountId: Int!, $token: String) {
    companyLogo(accountId: $accountId, token: $token) {
      url
    }
  }
`
